export default "__VITE_ASSET__DX8Nkjf4__"